<template>
	<div class="tab-text">
		<h3 class="mb-5">{{ result.shipName }}</h3>
		<div class="w-full flex flex-wrap" v-if="result.shipName != 'Radiance of the Seas'">
			<div class="w-full lg:w-1/2 sm:w-1/1 pr-4">
				<vx-card class="h-100">
					<p>
						If thrills are what you seek, you'll love Ovation of the Seas
						action-packed activity lineup, including an onboard skydiving
						simulator and trapeze classes, FlowRider surfing simulator, and the
						incredible 360 degree views offered by the North Star glass capsule,
						300 feet above sea level.
					</p>
					<vs-divider />
					<div class="flex">
						<div class="text-sm w-1/2 pr-4">
							<div class="flex justify-between mb-2">
								<span class="whitespace-no-wrap truncate mr-4"
									>Cruise Line</span
								>
								<span class="text-black whitespace-no-wrap truncate">{{
									result.cruiseLine
								}}</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Builder</span>
								<span class="text-black">Meyer Werft</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Entered Service </span>
								<span class="text-black">2016</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Length (ft)</span>
								<span class="text-black">339</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Beam (ft)</span>
								<span class="text-black">41</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Draft (ft)</span>
								<span class="text-black">0</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Tonnage</span>
								<span class="text-black">168666</span>
							</div>
						</div>
						<div class="text-sm w-1/2 pl-4">
							<div class="flex justify-between mb-2">
								<span>Cruise Style</span>
								<span class="text-black">Standard</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Size</span>
								<span class="text-black">Large</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Passenger Decks</span>
								<span class="text-black">16</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Cabins</span>
								<span class="text-black">2090</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Total Crew</span>
								<span class="text-black">1300</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Max. Passengers</span>
								<span class="text-black">4180</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Passenger/Crew Ratio</span>
								<span class="text-black">1 : 0.3 </span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Passenger/Space Ratio</span>
								<span class="text-black">1 : 40.4</span>
							</div>
						</div>
					</div>
				</vx-card>
			</div>
			<!-- https://github.com/vuejs/vue-loader/issues/646#issuecomment-389089479 -->

			<div
				class="w-full lg:w-1/2 sm:w-1/1 pl-4 rounded"
				style="background-size: cover; background-position: center center"
				v-bind:style="{
					backgroundImage:
						'url(' +
						require('@/assets/images/cruise-ship-images/ovation-of-the-seas.jpg') +
						')',
				}"
			></div>
		</div>
		<div class="w-full flex flex-wrap" v-else>
			<div class="w-full lg:w-1/2 sm:w-1/1 pr-4">
				<vx-card class="h-100">
					<p>

The feature that keeps line loyalists coming back to Radiance of the Seas is its dazzling ocean views available from just about anywhere, thanks to the ship's glassy exterior, allowing passengers to see what lies on the horizon on any of its global itineraries.
					</p>
					<vs-divider />
					<div class="flex">
						<div class="text-sm w-1/2 pr-4">
							<div class="flex justify-between mb-2">
								<span class="whitespace-no-wrap truncate mr-4"
									>Cruise Line</span
								>
								<span class="text-black whitespace-no-wrap truncate">{{
									result.cruiseLine
								}}</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Builder</span>
								<span class="text-black">Meyer Werft</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Entered Service </span>
								<span class="text-black">2001</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Length (ft)</span>
								<span class="text-black">339</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Beam (ft)</span>
								<span class="text-black">41</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Draft (ft)</span>
								<span class="text-black">0</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Tonnage</span>
								<span class="text-black">168666</span>
							</div>
						</div>
						<div class="text-sm w-1/2 pl-4">
							<div class="flex justify-between mb-2">
								<span>Cruise Style</span>
								<span class="text-black">Standard</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Size</span>
								<span class="text-black">Mid-Size</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Passenger Decks</span>
								<span class="text-black">12</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Cabins</span>
								<span class="text-black">1072</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Total Crew</span>
								<span class="text-black">858</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Max. Passengers</span>
								<span class="text-black">2146</span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Passenger/Crew Ratio</span>
								<span class="text-black">1 : 0.4 </span>
							</div>
							<div class="flex justify-between mb-2">
								<span>Passenger/Space Ratio</span>
								<span class="text-black">1 : 42</span>
							</div>
						</div>
					</div>
				</vx-card>
			</div>
			<!-- https://github.com/vuejs/vue-loader/issues/646#issuecomment-389089479 -->

			<div
				class="w-full lg:w-1/2 sm:w-1/1 pl-4 rounded"
				style="background-size: cover; background-position: center center"
				v-bind:style="{
					backgroundImage:
						'url(' +
						require('@/assets/images/cruise-ship-images/radiance-of-the-seas.jpg') +
						')',
				}"
			></div>
		</div>

	</div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      required: true
    }
  }
}
</script>
